import React,  {useState} from "react";
import {Autocomplete} from "@mui/material";
import {Search, CheckSharp} from "@material-ui/icons";
import {TextField} from "@material-ui/core";

const SearchAutocomplete = ({ optionList, selectedOptions, onSelectOption }) => {

    const [searchValue, setSearchValue] = useState('')

    const onSearchOptionHandler = (value, reason) => {
        if( reason !== 'reset') setSearchValue(value)
    }

    return <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={optionList}
            defaultValue={selectedOptions}
            sx={{ width: 1 }}
            popupIcon={<Search/>}
            disableCloseOnSelect={true}
            includeInputInList={true}
            multiple={true}
            disableClearable={true}
            selectOnFocus={true}
            renderTags={() => null}
            inputValue={searchValue}
            autoHighlight
            onClose={() => setSearchValue('')}
            onInputChange={(e, value, reason) => onSearchOptionHandler(value, reason)}
            onChange={(e,value)=>onSelectOption(e.target.innerText)}
            renderInput={(params) => <TextField {...params} placeholder="Search Group" />}
            renderOption={(props, option, { selected }) => (
                <li {...props} style={{backgroundColor: 'white'}}>
                    <div style={{
                        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                        margin: '0 15px',
                        width: '100%',
                        textAlign: 'left'}}>
                        <CheckSharp htmlColor={selectedOptions.includes(option) ? '#0B5394' : 'rgba(0, 0, 0, 0)'} />
                        <span style={{marginLeft: '5px'}}>{option}</span>
                    </div>
                </li>
            )}
        />


}
export default SearchAutocomplete
